import { create } from "zustand";

const channel = new BroadcastChannel("zustand_channel"); // Broadcast channel for communication across tabs

const useFormStore = create((set) => ({
  formData: {},

  // Set an input value
  setInputValue: (name, value) => {
    set((state) => {
      const newFormData = { ...state.formData, [name]: value };
      channel.postMessage({ type: "update", payload: newFormData }); // Broadcast the updated form data
      return { formData: newFormData };
    });
  },

  // Reset all form data
  resetForm: () => {
    const resetData = {}; // Reset to an empty object
    channel.postMessage({ type: "reset", payload: resetData }); // Broadcast the reset action
    set({ formData: resetData });
  },

  setFormData: (data) => {
    set((state) => {
      return { formData: { ...state.formData, ...data } };
    });
  },
}));

// Listen for state changes or reset actions from other tabs
channel.addEventListener("message", (event) => {
  const { type, payload } = event.data;

  if (type === "update") {
    useFormStore.setState({ formData: payload }); // Sync updated form data
  } else if (type === "reset") {
    useFormStore.setState({ formData: payload }); // Reset the form data
  }
});

export default useFormStore;
